import { render, staticRenderFns } from "./headtabr.vue?vue&type=template&id=1fff288f&scoped=true&"
import script from "./headtabr.vue?vue&type=script&lang=js&"
export * from "./headtabr.vue?vue&type=script&lang=js&"
import style0 from "./headtabr.vue?vue&type=style&index=0&id=1fff288f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff288f",
  null
  
)

export default component.exports